<template>
  <div class="childtrackingsystem-triggers">
    <div v-if="!isAnalyse" class="row bg-white">
      <div class="col-md-12"><br>
        <table class="table">
          <thead>
          <tr>
            <th>Observatielijst</th>
              <th class="text-end pe-1">
                <span
                    data-bs-toggle="modal"
                    data-bs-target="#infoModal"
                >
                    <icon name="info"></icon>
                </span>
              </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(trigger, key) in results" v-bind:key="key">
            <td><b>{{ trigger.listTitle }}</b> van kind <b>{{ trigger.childName }}</b> opgeslagen op {{ trigger.dateAnalyse }} (herinneringsdatum: {{ trigger.dateTrigger }})</td>
            <td class="text-end me-1" style="width:120px;">
              <span
                style="margin-top: 5px; margin-right: 15px;color:#666;"
                title="Bekijk"
                @click="openAnalyse(trigger.idResult)"
              >
                <icon name="look-into"></icon>
              </span>
              <span
                style="margin-top: 5px; margin-right: 15px;"
                title="Wis"
                @click="deleteTrigger(trigger.id)"
              >
                <icon name="delete"></icon>
              </span>
            </td>
          </tr>
          <tr v-if="results.length === 0">
            <td colspan="7">Geen herinneringen actief</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modalLoader" v-if="isLoading">
      <img src="../../assets/img/loading.gif" style="width: 80px; height: 80px;"/>
    </div>

    <div
      class="modal fade"
      id="infoModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header">
                  <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                  ></button>
              </div>
              <div class="modal-body">
                  <div class="row">
                      <div class="col-3">
                          <icon name="look-into"></icon>
                      </div>
                      <div class="col-9">Bekijk observatielijst</div>
                  </div>
                  <div class="row">
                      <div class="col-3">
                          <icon name="delete"></icon>
                      </div>
                      <div class="col-9">Verwijder herinnering</div>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div v-if="isAnalyse">
      <childtrackingsystem-editchildobservationlist :idResult="selectedResult"></childtrackingsystem-editchildobservationlist>
    </div>
  </div>
</template>
<script>
import ChildtrackingsystemEditchildobservationlist from "./EditObservationList";
import icon from "@/components/Icon.vue";
export default {
  name: 'childtrackingsystem-triggers',
  components: {icon, ChildtrackingsystemEditchildobservationlist},
  data() {
    return {
      isLoading: false,
      results: [],
      isAnalyse: false,
      analysedChildren: [],
      listTitle: null,
      categories: [],
      answers: [],
      checkedAnswer: [],
      checkedList: null,
      idResult: null,
      childId: null,
      listId: null,
      categoryId: null,
      isModalInfo: false,
      selectedResult: 0
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.getResults()
  },
  methods: {
    changeAnswer(event, childId, questionId, answerId) {
      if (!this.checkedAnswer[childId]) this.checkedAnswer[childId] = []
      this.checkedAnswer[childId][questionId] = answerId
      return this.checkedAnswer[childId][questionId]
    },
    getResults() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/triggers', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString, // @todo Fix for all groups
      }).then((response) => {
        this.isLoading = false
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response.savedTriggers) {
          this.results = response.savedTriggers
        }
      })
    },
    deleteTrigger(idTrigger) {
      if (confirm("Weet u zeker dat u de herinnering wilt verwijderen?")) {
        this.isLoading = true
        this.$store.commit('REGISTER_ACTIVE_REQUEST')
        this.$request.post('/ChildTrackingSystem/deleteTrigger', {
          idTrigger: idTrigger
        }).then((response) => {
          this.$store.commit('REMOVE_ACTIVE_REQUEST')
          if (response) {
            this.isLoading = false
            this.isAnalyse = false
            this.getResults()
          }
        })
      }
    },
    closeModal() {
      this.isModalInfo = false
    },
    seeLegenda() {
      this.isModalInfo = true
    },
    openAnalyse(idResult) {
      this.isAnalyse = true
      this.selectedResult = idResult
    }
  }
}
</script>
<style scoped>
.table {
  width: 100%;
}

.table th {
  color: #666;
  background-color: #f0f0f5;
  border-top: 1px solid #ddd !important;
}

.table td {
  border-bottom: 1px solid #ddd !important;
  color: #666;
}

.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.modalInfo {
  position: absolute;
  z-index: 1;
  left: 100px;
  top: 100px;
  width: 500px;
  height: 330px;
  overflow: auto;

}
</style>